import { computed, useAttrs } from 'vue'

const defaultSizes = {
  xl: { fontSize: '24px' },
  lg: { fontSize: '20px' },
  md: { fontSize: '16px' },
  sm: { fontSize: '12px' },
  xs: { fontSize: '10px' }
}

const defaultIconSizes = {
  xl: { fontSize: '24px' },
  lg: { fontSize: '20px' },
  md: { fontSize: '24px' },
  sm: { fontSize: '12px' },
  xs: { fontSize: '10px' }
}

export const useButton = ({ isIcon = false } = {}) => {
  const { size } = useAttrs()
  const sizes = isIcon ? defaultIconSizes : defaultSizes

  const style = computed(() => {
    const style = size
      ? size in sizes
        ? sizes[size]
        : { fontSize: size }
      : sizes.md

    return style
  })

  return { style }
}
